import { render, staticRenderFns } from "./UsersHeader.vue?vue&type=template&id=4f1d0103&scoped=true"
import script from "./UsersHeader.vue?vue&type=script&lang=js"
export * from "./UsersHeader.vue?vue&type=script&lang=js"
import style0 from "./UsersHeader.vue?vue&type=style&index=0&id=4f1d0103&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d0103",
  null
  
)

export default component.exports